export default __webpack_public_path__ + "static/media/2515.e6c10c3c.png";